import { render, staticRenderFns } from "./AnswersEditBlock.vue?vue&type=template&id=38632291&scoped=true"
import script from "./AnswersEditBlock.vue?vue&type=script&lang=js"
export * from "./AnswersEditBlock.vue?vue&type=script&lang=js"
import style0 from "./AnswersEditBlock.vue?vue&type=style&index=0&id=38632291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38632291",
  null
  
)

export default component.exports